import { render, staticRenderFns } from "./UndoneTrouble.vue?vue&type=template&id=44be7f38"
import script from "./UndoneTrouble.vue?vue&type=script&lang=js"
export * from "./UndoneTrouble.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports